import { render, staticRenderFns } from "./AffiliateCompensation.vue?vue&type=template&id=2edc500a&"
import script from "./AffiliateCompensation.vue?vue&type=script&lang=js&"
export * from "./AffiliateCompensation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports